import { render, staticRenderFns } from "./CreateClaimClaimInfo.vue?vue&type=template&id=0bee24f3"
import script from "./CreateClaimClaimInfo.vue?vue&type=script&lang=js"
export * from "./CreateClaimClaimInfo.vue?vue&type=script&lang=js"
import style0 from "./CreateClaimClaimInfo.vue?vue&type=style&index=0&id=0bee24f3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports